<script>
export default {
  props: {
    id: { type: String, required: true },
    item: { type: Object, required: true },
    eventBus: { type: Object, required: false }
  },
  methods: {
    doAction(action) {
      if (this.eventBus) {
        this.eventBus.$emit("card-action", action, this.item);
      } else {
        this.$emit("card-action", action, this.item);
      }
    }
  }
};
</script>